import { EBankAccountType, ECommissioningType, EConsumerUnitClassification, EContractFilterListPendencies, EContractStatus, EPersonType, EConsumerUnitTension, EDealershipResolutionModality, EDiscountTableType, EInvoiceCancelReason, EInvoiceStatus, ELossReason, EMaritalStatus, EPowerPlantModality, EProposalFilterListPendencies, EProposalOrigin, EProposalStatus, EStage, ETariffClassification, EUserType, EBillingType, ENotificationRecipient, EPendenciesStatus, EInvoicePaymentType, EContractLossReason } from '~/graphql/types'
import { CONTRAC_INVOICE, PROPOSAL_ORIGIN, translateContractInvoice, translateContractLossReason, translateContractStatus, translatEInvoiceCancelReason, translateLossReason, translateProposalContractOrigin, translateStageFunnel } from './translate'

export type Option = {
  label: string,
  value: string
  tooltipLabel?: string
}

export type OptionBooleanRadio = {
  label: string,
  value: boolean
  tooltipLabel?: string
}

export const defaultOption: Option = {
  value: '', label: ''
}

export const personTypeOptions: Option[] = [
  { value: EPersonType.pf, label: 'Pessoa Física' },
  { value: EPersonType.pj, label: 'Pessoa Jurídica' }
]

export const maritalStatusOptions: Option[] = [
  { value: EMaritalStatus.married, label: 'Casado(a)' },
  { value: EMaritalStatus.single, label: 'Solteiro(a)' },
  { value: EMaritalStatus.divorced, label: 'Divorciado(a)' },
  { value: EMaritalStatus.widowed, label: 'Viúvo(a)' }
]

export const tariffClassificationOptions: Option[] = [
  { value: ETariffClassification.A4, label: 'A4' },
  { value: ETariffClassification.B1, label: 'B1' },
  { value: ETariffClassification.B2, label: 'B2' },
  { value: ETariffClassification.B3, label: 'B3' }
]

export const customerTensionOptions: Option[] = [
  { value: EConsumerUnitTension.monofasico, label: 'Monofásico' },
  { value: EConsumerUnitTension.bifasico, label: 'Bifásico' },
  { value: EConsumerUnitTension.trifasico, label: 'Trifásico' }
]

export const userTypeOptions: Option[] = [
  { value: EUserType.internal, label: 'Interno' },
  { value: EUserType.seller, label: 'Vendedor' },
]

export const getConsumerClassificationOptions = (tariffClassification: ETariffClassification | ETariffClassification): Option[] => {
  switch (tariffClassification) {
  case ETariffClassification.A4:
    return [
      { value: EConsumerUnitClassification.industrial, label: 'Industrial' }
    ]
  case ETariffClassification.B1:
    return [
      { value: EConsumerUnitClassification.residencial, label: 'Residencial' }
    ]
  case ETariffClassification.B2:
    return [
      { value: EConsumerUnitClassification.rural, label: 'Rural' }
    ]
  case ETariffClassification.B3:
    return [
      { value: EConsumerUnitClassification.comercial, label: 'Comercial' },
      { value: EConsumerUnitClassification.industrial, label: 'Industrial' }
    ]
  default:
    return [defaultOption]
  }
}

export const proposalStatusOptions: Option[] = [
  { value: EProposalStatus.canceled, label: 'Cancelado' },
  { value: EProposalStatus.documentation, label: 'Documentação' },
  { value: EProposalStatus.finalized, label: 'Finalizado' },
  { value: EProposalStatus.formalization, label: 'Formalização' }
]

export const contractStatusOptions: Option[] = [
  { value: EContractStatus.cancellationRequested, label: translateContractStatus(EContractStatus.cancellationRequested) },
  { value: EContractStatus.deactivated, label: translateContractStatus(EContractStatus.deactivated) },
  { value: EContractStatus.inDeactivation, label: translateContractStatus(EContractStatus.inDeactivation) },
  { value: EContractStatus.reserved, label: translateContractStatus(EContractStatus.reserved) },
  { value: EContractStatus.sent, label: translateContractStatus(EContractStatus.sent) },
  { value: EContractStatus.signatures, label: translateContractStatus(EContractStatus.signatures) },
  { value: EContractStatus.active, label: translateContractStatus(EContractStatus.active) }
]

export const contractPendenciesOptions: Option[] = [
  { value: EContractFilterListPendencies.signTermAdhesion, label: 'Termo de adesão assinado' },
  { value: EContractFilterListPendencies.signTermManagement, label: 'Termo de gestão assinado' },
]

export const bankAccountTypeOptions: Option[] = [
  { value: EBankAccountType.cc, label: 'Conta corrente' },
  { value: EBankAccountType.cp, label: 'Poupança' }
]

export const invoiceTypeOptions: Option[] = [
  { value: 'C', label: 'Entrada' },
  { value: 'D', label: 'Saída' }
]

export const discountTableOptions: Option[] = [
  { value: EDiscountTableType.customerFloatFlag, label: 'Sim' },
  { value: EDiscountTableType.customerNotFloatFlag, label: 'Não' }
]

export const powerPlantModalityOptions: Option[] = [
  { value: EPowerPlantModality.gd1, label: 'GD I' },
  { value: EPowerPlantModality.gd2, label: 'GD II' },
  { value: EPowerPlantModality.gd3, label: 'GD III' },
]

export const dealershipModalityOptions: Option[] = [
  { value: EDealershipResolutionModality.conventional, label: 'Convencional' },
  { value: EDealershipResolutionModality.notConventional, label: 'Não convencional' }
]

export const ProposalPendenciesOptions: Option[] = [
  { value: EProposalFilterListPendencies.addressData, label: 'Endereço' },
  { value: EProposalFilterListPendencies.documentation, label: 'Documentação' },
  { value: EProposalFilterListPendencies.energyBill, label: 'Fatura de energia' },
  { value: EProposalFilterListPendencies.personalData, label: 'Dados pessoais' },
  // { value: EProposalFilterListPendencies.signTermAdhesion, label: 'Termo de gestão assinado' },
]

export const ProposalPendingDocumentsOptions: Option[] = [
  { value: EPendenciesStatus.fullyResolved, label: 'Informações completas recebidas', tooltipLabel: 'O cliente enviou todas as informações necessárias à proposta' },
  { value: EPendenciesStatus.partiallyResolved, label: 'Informações parciais recebidas', tooltipLabel: 'O cliente enviou algumas das informações necessárias à proposta' },
  { value: EPendenciesStatus.documentationFullyReceived, label: 'Documentação completa recebida' }

]
export const ContractPendingDocumentsOptions: Option[] = [
  { value: EPendenciesStatus.fullyResolved, label: 'Informações completas recebidas', tooltipLabel: 'O cliente enviou todas as informações necessárias ao contrato' },
  { value: EPendenciesStatus.partiallyResolved, label: 'Informações parciais recebidas', tooltipLabel: 'O cliente enviou algumas das informações necessárias ao contrato' },
]

export const ProposalContractOriginOptions: Option[] = [
  { value: EProposalOrigin.partnerLink, label: translateProposalContractOrigin(EProposalOrigin.partnerLink, PROPOSAL_ORIGIN) },
  { value: EProposalOrigin.partner, label: translateProposalContractOrigin(EProposalOrigin.partner, PROPOSAL_ORIGIN) },
  { value: EProposalOrigin.partnerApi, label: translateProposalContractOrigin(EProposalOrigin.partnerApi, PROPOSAL_ORIGIN) },
  { value: EProposalOrigin.website, label: translateProposalContractOrigin(EProposalOrigin.website, PROPOSAL_ORIGIN) },
  { value: EProposalOrigin.rdStation, label: translateProposalContractOrigin(EProposalOrigin.rdStation, PROPOSAL_ORIGIN) },
  { value: EProposalOrigin.internal, label: translateProposalContractOrigin(EProposalOrigin.internal, PROPOSAL_ORIGIN) },
  { value: EProposalOrigin.customer, label: translateProposalContractOrigin(EProposalOrigin.customer, PROPOSAL_ORIGIN) },
]

export const contractInvoiceOptions: Option[] = [
  { value: EInvoiceStatus.canceled, label: translateContractInvoice(EInvoiceStatus.canceled, CONTRAC_INVOICE) },
  { value: EInvoiceStatus.late, label: translateContractInvoice(EInvoiceStatus.late, CONTRAC_INVOICE) },
  { value: EInvoiceStatus.paid, label: translateContractInvoice(EInvoiceStatus.paid, CONTRAC_INVOICE) },
  { value: EInvoiceStatus.pending, label: translateContractInvoice(EInvoiceStatus.pending, CONTRAC_INVOICE) },
  { value: EInvoiceStatus.expired, label: translateContractInvoice(EInvoiceStatus.expired, CONTRAC_INVOICE) },
  { value: EInvoiceStatus.externalNegotiation, label: translateContractInvoice(EInvoiceStatus.externalNegotiation, CONTRAC_INVOICE) },
  // { value: EInvoiceStatus.requested, label: translateContractInvoice(EInvoiceStatus.requested, CONTRAC_INVOICE) },
]

export const invoicePaymentTypeOptions: Option[] = [
  { value: EInvoicePaymentType.internal, label: 'Pagamento interno' },
  { value: EInvoicePaymentType.external, label: 'Pagamento externo' },
]

export const byInvoiceOptions: Option[] = [
  { value: 'false', label: '1ª via' },
  { value: 'true', label: '2ª via' },
]

export const lossReasonOptions: Option[] = [
  { value: ELossReason.areaNotCovered, label: translateLossReason(ELossReason.areaNotCovered) },
  { value: ELossReason.beneficiaryDueToLowIncome, label: translateLossReason(ELossReason.beneficiaryDueToLowIncome) },
  { value: ELossReason.buildingOwnPlantOrAlreadyHasOne, label: translateLossReason(ELossReason.buildingOwnPlantOrAlreadyHasOne) },
  { value: ELossReason.closedWithCompetitor, label: translateLossReason(ELossReason.closedWithCompetitor) },
  { value: ELossReason.companyChangingPartners, label: translateLossReason(ELossReason.companyChangingPartners) },
  { value: ELossReason.companyDeactivated, label: translateLossReason(ELossReason.companyDeactivated) },
  { value: ELossReason.delinquent, label: translateLossReason(ELossReason.delinquent) },
  { value: ELossReason.didNotSendDocumentation, label: translateLossReason(ELossReason.didNotSendDocumentation) },
  { value: ELossReason.didNotUnderstandTheSolution, label: translateLossReason(ELossReason.didNotUnderstandTheSolution) },
  { value: ELossReason.disagreesWithContractTerms, label: translateLossReason(ELossReason.disagreesWithContractTerms) },
  { value: ELossReason.doesNotIntendToLeaveUtility, label: translateLossReason(ELossReason.doesNotIntendToLeaveUtility) },
  { value: ELossReason.duplicateLead, label: translateLossReason(ELossReason.duplicateLead) },
  { value: ELossReason.incorrectEmail, label: translateLossReason(ELossReason.incorrectEmail) },
  { value: ELossReason.insufficientInvoiceAmount, label: translateLossReason(ELossReason.insufficientInvoiceAmount) },
  { value: ELossReason.invalidOrMissingPhone, label: translateLossReason(ELossReason.invalidOrMissingPhone) },
  { value: ELossReason.isInFreeMarket, label: translateLossReason(ELossReason.isInFreeMarket) },
  { value: ELossReason.leadCreatedForTesting, label: translateLossReason(ELossReason.leadCreatedForTesting) },
  { value: ELossReason.linkExpiredAfter30Days, label: translateLossReason(ELossReason.linkExpiredAfter30Days) },
  { value: ELossReason.lostToPartner, label: translateLossReason(ELossReason.lostToPartner) },
  { value: ELossReason.noContactReturned, label: translateLossReason(ELossReason.noContactReturned) },
  { value: ELossReason.noInterestLostInterest, label: translateLossReason(ELossReason.noInterestLostInterest) },
  { value: ELossReason.publicAgency, label: translateLossReason(ELossReason.publicAgency) },
  { value: ELossReason.registrationMismatchWithInvoice, label: translateLossReason(ELossReason.registrationMismatchWithInvoice) },
  { value: ELossReason.rejectedByCredit, label: translateLossReason(ELossReason.rejectedByCredit) },
  { value: ELossReason.rejectedByGenerator, label: translateLossReason(ELossReason.rejectedByGenerator) },
  { value: ELossReason.wantedDifferentDiscountPercentage, label: translateLossReason(ELossReason.wantedDifferentDiscountPercentage) },
  { value: ELossReason.suspectedFraud, label: translateLossReason(ELossReason.suspectedFraud) },
  { value: ELossReason.other, label: translateLossReason(ELossReason.other) },
  
]

export const contractLossReasonOptions: Option[] = [
  { value: EContractLossReason.areaNotCovered, label: translateContractLossReason(EContractLossReason.areaNotCovered) },
  { value: EContractLossReason.beneficiaryDueToLowIncome, label: translateContractLossReason(EContractLossReason.beneficiaryDueToLowIncome) },
  { value: EContractLossReason.buildingOwnPlantOrAlreadyHasOne, label: translateContractLossReason(EContractLossReason.buildingOwnPlantOrAlreadyHasOne) },
  { value: EContractLossReason.closedWithCompetitor, label: translateContractLossReason(EContractLossReason.closedWithCompetitor) },
  { value: EContractLossReason.companyChangingPartners, label: translateContractLossReason(EContractLossReason.companyChangingPartners) },
  { value: EContractLossReason.companyDeactivated, label: translateContractLossReason(EContractLossReason.companyDeactivated) },
  { value: EContractLossReason.delinquent, label: translateContractLossReason(EContractLossReason.delinquent) },
  { value: EContractLossReason.didNotUnderstandTheSolution, label: translateContractLossReason(EContractLossReason.didNotUnderstandTheSolution) },
  { value: EContractLossReason.duplicateLead, label: translateContractLossReason(EContractLossReason.duplicateLead) },
  { value: EContractLossReason.leadCreatedForTesting, label: translateContractLossReason(EContractLossReason.leadCreatedForTesting) },
  { value: EContractLossReason.lostToPartner, label: translateContractLossReason(EContractLossReason.lostToPartner) },
  { value: EContractLossReason.rejectedByGenerator, label: translateContractLossReason(EContractLossReason.rejectedByGenerator) },
  { value: EContractLossReason.suspectedFraud, label: translateContractLossReason(EContractLossReason.suspectedFraud) },
  { value: EContractLossReason.other, label: translateContractLossReason(EContractLossReason.other) },
]

export const invoiceCanceledReasonOptions: Option[] = [
  { value: EInvoiceCancelReason.clientNegotiation, label: translatEInvoiceCancelReason(EInvoiceCancelReason.clientNegotiation) },
  { value: EInvoiceCancelReason.clientRetention, label: translatEInvoiceCancelReason(EInvoiceCancelReason.clientRetention) },
  { value: EInvoiceCancelReason.incorrectData, label: translatEInvoiceCancelReason(EInvoiceCancelReason.incorrectData) },
  { value: EInvoiceCancelReason.incorrectInvoice, label: translatEInvoiceCancelReason(EInvoiceCancelReason.incorrectInvoice) },
  { value: EInvoiceCancelReason.other, label: translatEInvoiceCancelReason(EInvoiceCancelReason.other) },
  { value: EInvoiceCancelReason.systemError, label: translatEInvoiceCancelReason(EInvoiceCancelReason.systemError) },
  { value: EInvoiceCancelReason.wrongAmount, label: translatEInvoiceCancelReason(EInvoiceCancelReason.wrongAmount) },
  
]

export const funnelStageOptions: Option[] = [
  { value: EStage.lead, label: translateStageFunnel(EStage.lead) },
  { value: EStage.opportunity, label: translateStageFunnel(EStage.opportunity) },
  { value: EStage.negotiating, label: translateStageFunnel(EStage.negotiating) },
  { value: EStage.negotiationCoolingDown, label: translateStageFunnel(EStage.negotiationCoolingDown) },
  { value: EStage.firstContactAttempt, label: translateStageFunnel(EStage.firstContactAttempt) },
  { value: EStage.secondContactAttempt, label: translateStageFunnel(EStage.secondContactAttempt) },
  { value: EStage.thirdContactAttempt, label: translateStageFunnel(EStage.thirdContactAttempt) },
  { value: EStage.contactReestablished, label: translateStageFunnel(EStage.contactReestablished) },
  { value: EStage.awaitingSignature, label: translateStageFunnel(EStage.awaitingSignature) },
  { value: EStage.legalAssembly, label: translateStageFunnel(EStage.legalAssembly) },
  { value: EStage.proposalContracted, label: translateStageFunnel(EStage.proposalContracted) },
  { value: EStage.lost, label: translateStageFunnel(EStage.lost) },
]

export const partnerStatusOptions: Option[] = [
  { value: 'active', label: 'Ativo' },
  { value: 'inactive', label: 'Inativo' },
]

export const booleanOptions: OptionBooleanRadio[] = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' },
]

export const comissionTypeOptions: Option[] = [
  { value: ECommissioningType.recurring, label: 'Recorrente' },
  { value: ECommissioningType.anticipated, label: 'Inicial' },
]

export const dealershipNeedLoginOptions: OptionBooleanRadio[] = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' },
]

export const billingModelOptions: Option[] = [
  { value: EBillingType.keepsBenefit, label: 'Mantém o benefício' },
  { value: EBillingType.losesBenefit, label: 'Perde o benefício' }
]

export const ProposalPendingAnalysisRejected: Option[] = [
  { value: EPendenciesStatus.rejected, label: 'Informações recusadas', tooltipLabel: 'Informações necessárias à proposta foram recusadas' },
]
export const ContractPendingAnalysisRejected: Option[] = [
  { value: EPendenciesStatus.rejected, label: 'Informações recusadas', tooltipLabel: 'Informações necessárias ao contrato foram recusadas' },
]

export const notificationRecipientOptions: Option[] = [
  { value: ENotificationRecipient.customer, label: 'Notificar cliente' },
  { value: ENotificationRecipient.partner, label: 'Notificar parceiro' },
]
